import { render, staticRenderFns } from "./transactionStatusIcon.vue?vue&type=template&id=3b861a99"
import script from "./transactionStatusIcon.vue?vue&type=script&lang=js"
export * from "./transactionStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports